<template>
  <div class="vx-row student-list-container">
    <div class="vx-col mb-2" style="width: 200px" v-for="index in count" :key="index">
      <vx-card style="border-radius: 90px 90px 30px 30px;">
        <div slot="no-body">
          <!-- <img id="studentprofilepic" :src="student.profilePicUrl" alt="content-img" class="responsive card-img-top" /> -->
          <custom-skeleton style="padding: 6px;" class="responsive card-img-top" animation="wave" type="avatar" :count="1" height="160px" width="160px"></custom-skeleton>
        </div>
        <custom-skeleton animation="wave" type="text" :count="1" height="21px" width="130px"></custom-skeleton>
      </vx-card>
    </div>
  </div>
</template>

<script>
import CustomSkeleton from './CustomSkeleton.vue'

export default {
  data(){
    return{
    }
  },
  components:{
    CustomSkeleton
  },
  props:{
    count: {
      type: Number,
      required: true
    },
  },
  methods:{
  },
  mounted(){
  },
  
}
</script>



<style scoped lang="scss">
.skeleton-loading-card{
  .data-card{
    box-shadow: 3px 3px 6px 3px rgba(0, 0, 0, 0.2) !important;
    transition: transform .15s ease-in, box-shadow .2s ease-in;
    border-radius: 15px;
    width: 300px;
    height: 290px;
    cursor: pointer;
    &:hover {
      transform: scale(1.035);
      box-shadow: 0px 5px 6px 3px rgba(0, 0, 0, 0.3) !important;
    }
    .data-card-header{
      padding: 5px;
      height: 60px;
      margin-bottom: 0px;
      border-radius: 15px 15px 0px 0px;
      //background-color: rgba(var(--vs-primary),100);
      background: linear-gradient(to right, rgba(var(--vs-primary), 1), rgba(var(--vs-secondary), 1));
      display: flex;
      h1{
        font-size: 24px;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: auto;
      }
    }
    .data-card-content{
      padding: 10px 10px 20px 10px;
      position: relative;
      background-color: #101738;
      height: 230px;
      border-radius: 0px 0px 15px 15px ;
      .score{
        left: 10px;
      }
      h6{
        position: absolute;
      }
      .h6-lower{
        top: 42px;
      }
    }
    .data-label{
      display: flex;
      justify-content: space-evenly;
      flex-direction: row;
      .data-my-avg::before{
        background-color: rgba(var(--vs-primary),100)
      }
      .data-avg::before{
        background-color: white;
      }
      p::before{
        content: '';
        border-radius: 50%;
        height: 10px;
        width: 10px;
        margin-right: 5px;
        display: inline-block;
      }
    }
    .radial-move{
      margin-top: -20px;
      justify-content: center;
    }
  }
}

@media screen and(max-width:837px){
    .student-list-container{
      justify-content: center;
    }
  }

</style>
